import React from 'react';

import { Row } from '../atoms/row';
import { LinkComponent } from '../atoms/link-component';

import { Inspect as InspectComp } from '../templates/inspect';

export const InspectInverter = () => {
  return (
    <>
      <h1>Inspect Inverter</h1>

      <Row gap={1}>
        <LinkComponent to="/inspect">Home</LinkComponent>
        <LinkComponent to="/inspect/inverter">Inverter</LinkComponent>
        <LinkComponent to="/inspect/wallbox">Wallbox</LinkComponent>
        <LinkComponent to="/inspect/heat-pump">Heat pump</LinkComponent>
        <LinkComponent to="/inspect/mqtt">MQTT</LinkComponent>
        <LinkComponent to="/inspect/plugs">Plugs</LinkComponent>
        <LinkComponent to="/inspect/spot">Spot</LinkComponent>
        <LinkComponent to="/inspect/plc">PLC</LinkComponent>
      </Row>

      <InspectComp
        variableIds={[
          'PV_INVERTER_TYPE',
          'MODBUS_TEST_ADDRESS',
          'MODBUS_TEST_PORT',
          'PV_cnt_com_ok',
          'PV_cnt_com_err',
          'PV_cnt_com_write',
          'INVERTER_STATUS',
          'INVERTER_CONFIG',
          'INVERTER_STATS',
          'INVERTER_STATS_PERSISTED',
        ]}
      />
    </>
  );
};

export default InspectInverter;
